"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ScaleLegend_1 = __importDefault(require("./ScaleLegend"));

exports.default = ScaleLegend_1.default;